import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

/**
 * Lazy load the image while is visible on viewport
 * @param {img} img 
 * @param {alt} alt 
 * @param {classe} classe 
 * @returns  LasyLoad image component
 */
const LazyLoadImg = ({ img, alt, classe }) => {
    return ( 
        <LazyLoadImage
            src={img} 
            alt={alt}
            effect="blur"
            className={ `${classe}`}
        />  
    )
}
 
export default LazyLoadImg;